(function () {
  var arts = document.querySelectorAll('.seo-art');
  if (!arts.length) return;
  function enter(el) { el.classList.add('has-entered', 'is-in'); }
  if (!('IntersectionObserver' in window)) { arts.forEach(enter); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var el = e.target;
      var loop = el.classList.contains('seo-art-flow');
      if (e.isIntersecting && e.intersectionRatio >= 0.25) {
        enter(el);
        if (!loop) io.unobserve(el);
      } else if (loop) {
        // Looping scene: only run while visible.
        el.classList.remove('is-in');
      }
    });
  }, { threshold: 0.25 });
  arts.forEach(function (el) { io.observe(el); });
})();
